import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/larkspur.jpg";

const CONFIG: SpokePageConfig = {
  slug: "web-design-seo-larkspur",
  metaTitle: "Larkspur Web Design & SEO | Local Google Maps Help",
  metaDescription: "Web design and SEO for Larkspur, CO businesses. Websites from $1,850, local SEO and Google Maps from $950/month. Based in Colorado Springs, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado Springs Headquarters", to: "/colorado-springs-headquarters" }],
  currentLabel: "Larkspur",
  eyebrow: "Larkspur, CO · Douglas County",
  h1: (
    <>
      Web Design &amp; SEO in <span className="text-brand-gold">Larkspur, Colorado</span>
    </>
  ),
  heroDescription: "Help Larkspur customers find you first on Google, Google Maps and AI search.",
  intro: "We build websites and local SEO for businesses in Larkspur, Perry Park and the I-25 gap between Castle Rock and Monument. Chris Heidlebaugh works from our Woodmen Rd office in Colorado Springs, within our 60-mile service area, with 27 years of experience helping local companies get found.",
  definition: { term: "Larkspur local SEO", body: "Making your business show up when people in and around Larkspur search Google, Google Maps and AI tools for what you offer." },
  whatWeDo: [
    { title: "Larkspur website", body: "A fast site with pages for your services and the Larkspur area." },
    { title: "Google Maps", body: "A complete profile with photos, services and steady reviews." },
    { title: "Nearby towns", body: "Pages for Castle Rock, Monument and Palmer Lake too." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
    { title: "Free audit", body: "See what is holding your Larkspur rankings back." },
  ],
  whyThisMarket: [
    { heading: "Local searches", body: "Spread-out properties mean customers search for who will come to them." },
    { heading: "Douglas County", body: "We know Douglas County and serve it from Colorado Springs." },
    { heading: "No long contracts", body: "Monthly marketing is month-to-month." },
  ],
  relatedLinks: [
    { to: "/marketing-larkspur", label: "Marketing in Larkspur: social, ads, reviews & Maps" },
    { to: "/colorado-springs-headquarters", label: "Our 60-mile service area" },
    { to: "/colorado-springs-office-woodmen-rd", label: "Our Woodmen Rd office" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
  ],
  faqs: [
    { q: "Do you work with businesses in Larkspur?", a: "Yes. Larkspur is in our 60-mile service area around Colorado Springs. We can meet in person or by video." },
    { q: "How much does a website cost?", a: "Websites are $1,850, $2,750 or $5,950 one-time with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Web Design and SEO in Larkspur, CO",
  serviceDescription: "Web design, local SEO and Google Maps help for Larkspur, Colorado businesses.",
  heroImage: { src: heroImg, alt: "Larkspur, Colorado red rocks and pine forests in the Rampart Range", geo: { lat: 39.2286, lng: -104.8872, city: "Larkspur, CO" } },
  areaServed: "Larkspur, CO",
};

export const Route = createFileRoute("/web-design-seo-larkspur")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
